module.exports = __webpack_public_path__ + "img/MELA_TMKI67.f214ab0c.png";